import React from 'react';
import { Modal, Table, Empty } from 'antd';
import moment from 'moment';
import classNames from 'classnames';
import { useGetQaSpecHistory } from './hooks/useGetQaSpecHistory';
import './DetailsQASpecHistory.less';

const DetailsQASpecHistory = ({ visible, onClose, productId }) => {
  const { data = [], isLoading } = useGetQaSpecHistory(productId, visible);

  const sortedData = [...data]
    .map((item) => ({
      key: item.id,
      updatedBy: item.lastModifiedByName || item.createdByName || '',
      lastUpdated: item.lastModified || item.created,
      status: item.qaSpecStatus,
    }))
    .sort((a, b) => moment(b.lastUpdated).diff(moment(a.lastUpdated)));

  const latestKey = sortedData[0]?.key;

  const columns = [
    {
      title: 'S.No.',
      dataIndex: 'key',
      key: 'key',
      render: (_, __, index) => index + 1,
      width: 80,
    },
    {
      title: 'Updated By',
      dataIndex: 'updatedBy',
      key: 'updatedBy',
    },
    {
      title: 'Last Updated',
      dataIndex: 'lastUpdated',
      key: 'lastUpdated',
      render: (date) => moment(date).format('YYYY-MM-DD HH:mm'),
    },
    {
      title: 'QA Spec Status',
      dataIndex: 'status',
      key: 'status',
      render: (text, record) => (
        <span
          className={classNames('status-cell', {
            'latest-status': record.key === latestKey,
          })}
        >
          {text}
        </span>
      ),
    },
  ];

  return (
    <Modal
      title='QA Specification Status History'
      visible={visible}
      onCancel={onClose}
      onOk={onClose}
      width={800}
    >
      <Table
        dataSource={sortedData}
        columns={columns}
        pagination={false}
        rowKey='key'
        size='small'
        scroll={{ y: 300 }}
        loading={isLoading}
        className='qa-spec-history-table'
        locale={{
          emptyText: <Empty description='No Data Found' />,
        }}
      />
    </Modal>
  );
};

export default DetailsQASpecHistory;
